// libs
import React from 'react';
// components
import { FieldProps, TextField, useFieldHelper } from 'framework/ui/field';
// services
import { getProbationReduction } from 'domain/shared/employee';

const FinanceProbationReductionField = ({ probationAmountSource, baseAmountSource, ...props }: FieldProps) => {
  const { getValue: getProbationAmountValue } = useFieldHelper({ source: probationAmountSource });
  const { getValue: getBaseAmountValue } = useFieldHelper({ source: baseAmountSource });

  const getFieldValue = () => {
    const probationAmount = getProbationAmountValue();
    const baseAmount = getBaseAmountValue();

    return `${getProbationReduction(probationAmount, baseAmount)}%`;
  };

  return <TextField value={getFieldValue()} {...props} />;
};

export default FinanceProbationReductionField;
